import {useEffect, useState} from 'react'
import apiClient from 'src/services/apiClient'
// eslint-disable-next-line no-restricted-imports
import PatientDigitalEnrollment from 'src/pages/patientDigitalEnrollment/PatientDigitalEnrollment'
import PatientDigitalEnrollmentPageNew from './PatientDigitalEnrollmentPageNew'
import ThemeProviderNew from 'src/theme-new/ThemeProviderNew'

// Same shape as src/pages-new/selfRegistration/SelfRegistrationGate.tsx — fetches the
// pre-auth login-configuration payload and branches on `newStyleEnabled`, since redux
// isn't populated yet at this point in the app lifecycle.
const PatientDigitalEnrollmentGate = () => {
  const [config, setConfig] = useState<any>()

  useEffect(() => {
    let mounted = true
    apiClient.loginConfiguration().then((res: any) => {
      if (mounted) setConfig(res)
    })
    return () => { mounted = false }
  }, [])

  if (!config) return null

  if (config.newStyleEnabled) {
    return (
      <ThemeProviderNew themeOverride={{primaryColor: config.primaryColor}}>
        <PatientDigitalEnrollmentPageNew config={config} />
      </ThemeProviderNew>
    )
  }

  return <PatientDigitalEnrollment />
}

export default PatientDigitalEnrollmentGate
